import styled from 'styled-components';
import { BodyText } from '@/utils/global-fonts';

const LinkAddAction = styled.div`
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  gap: 8px;
  width: auto;
  cursor: pointer;
`;
const ActionText = styled(BodyText)`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
  text-align: left;
  text-vertical-align: middle;
`;

const LinkListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;

  div {
    margin: 0px;
  }
`;

const styledLinkAdd = {
  LinkAddAction,
  ActionText,
  LinkListWrapper,
};

export default styledLinkAdd;
